import { decamelizeKeys } from 'humps';
import { SearchParamsOption } from 'ky';

import getClient from '../getClient';

export type ApiTeamSearchResponse = {
  data: Team[];
  meta: {
    status: number;
    success: boolean;
    total: number;
    page: number;
  };
};

export type Team = {
  id: number;
  name: string;
  enforce_unsubscribe?: boolean;
  prevent_agent_and_analyst_flow_creation: boolean;
  accounts_configuration: {
    id: number;
    team_id: number;
    has_salesforce_account_owners: boolean;
    has_associated_internal_accounts: boolean;
    associated_salesforce_field?: string;
    created_at: string;
    updated_at: string;
  };
};

export type TeamsSearchParams = {
  page: number;
  pageSize: number;
  search: string;
};

export const getTeams = (
  searchParams: TeamsSearchParams,
): Promise<ApiTeamSearchResponse> => {
  return getClient()
    .get(`api/v2/teams`, {
      searchParams: decamelizeKeys(searchParams) as SearchParamsOption,
    })
    .json();
};
